// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Home_header-title__5n61B {
  margin-bottom: 24px;
  color: #ffffff;
  font-size: 24px;
  font-weight: bold;
  z-index: 1;
}

.Home_header-content__Bg9\\+S {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.Home_header-content__Bg9\\+S::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.65) 19.38%, rgba(0, 0, 0, 0.3) 52.15%, rgba(0, 0, 0, 0.05) 88.61%);
}

.Home_catalog__s2KrK {
  display: flex;
  align-items: flex-start;
}
.Home_catalog__s2KrK .Home_side-menu__bGER2 {
  width: 17%;
}
.Home_catalog__s2KrK .Home_products-container__CkvOb {
  width: 83%;
  display: flex;
  flex-wrap: wrap;
}

.Home_see-more-container__rlrSS {
  display: flex;
  justify-content: flex-end;
  margin: 10px 5%;
}
.Home_see-more-container__rlrSS .Home_see-more__1NTmI {
  color: #054ab0;
}

.Home_pointer__LIICY {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/views/Home/Home.module.scss","webpack://./src/styles/_colors.scss","webpack://./src/styles/_typography.scss"],"names":[],"mappings":"AAGA;EACE,mBAAA;EACA,cCIM;EDHN,eEDS;EFET,iBAAA;EACA,UAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAFF;;AAKA;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,sHAAA;AAFF;;AAKA;EACE,aAAA;EACA,uBAAA;AAFF;AAIE;EACE,UAAA;AAFJ;AAKE;EACE,UAAA;EACA,aAAA;EACA,eAAA;AAHJ;;AAOA;EACE,aAAA;EACA,yBAAA;EACA,eAAA;AAJF;AAME;EACE,cC9CK;AD0CT;;AAQA;EACE,eAAA;AALF","sourcesContent":["@use \"styles/colors\";\n@use \"styles/typography\";\n\n.header-title {\n  margin-bottom: 24px;\n  color: colors.$white;\n  font-size: typography.$header-m;\n  font-weight: typography.$bold;\n  z-index: 1;\n}\n\n.header-content {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n\n.header-content::after {\n  content: \"\";\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(180deg, rgba(0, 0, 0, 0.65) 19.38%, rgba(0, 0, 0, 0.3) 52.15%, rgba(0, 0, 0, 0.05) 88.61%);\n}\n\n.catalog {\n  display: flex;\n  align-items: flex-start;\n\n  .side-menu {\n    width: 17%;\n  }\n\n  .products-container {\n    width: 83%;\n    display: flex;\n    flex-wrap: wrap;\n  }\n}\n\n.see-more-container {\n  display: flex;\n  justify-content: flex-end;\n  margin: 10px 5%;\n\n  .see-more {\n    color: colors.$accent;\n  }\n}\n\n.pointer {\n  cursor: pointer;\n}\n","$neutral: #333333;\n$neutral-700: #252525;\n$accent: #054ab0;\n$primary: #ff6b00;\n$primary-hover: #c75004;\n$secondary: #1f1f1f;\n$secondary-hover: #393939;\n$default: #666666;\n$light: #616c7a;\n$white: #ffffff;\n$light-blue: #ebf3ff;\n$color-background-02: #f2f2f2;\n$color-background-text: #fbfbfb;\n$color-text-02: #333333;\n$color-text-disabled: #808080;\n$color-button-disabled: #e9e9e9;\n$color-semantic-primary: #e6e6e6;\n$color-success-active: #008863;\n$color-success-disable: #32d2a7;\n$color-error-active: #a63631;\n$color-error-disable: #ff9590;\n$error: #c9423c;\n$text-link: #0058e1;\n$text-link-hover: #003b9c;\n$neutral-200: #696969;\n$error-200: #d73a3d;\n$warning-200: #ffb93c;\n$info-200: #1175c9;\n$success-300: #4ba564;\n$neutral-400: #bbbbbb;\n","$body-s: 12px;\n$body-m: 14px;\n$body-l: 16px;\n$header-xs: 18px;\n$header-s: 20px;\n$header-m: 24px;\n$header-l: 34px;\n$bold: bold;\n$semi-bold: 600;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header-title": `Home_header-title__5n61B`,
	"header-content": `Home_header-content__Bg9+S`,
	"catalog": `Home_catalog__s2KrK`,
	"side-menu": `Home_side-menu__bGER2`,
	"products-container": `Home_products-container__CkvOb`,
	"see-more-container": `Home_see-more-container__rlrSS`,
	"see-more": `Home_see-more__1NTmI`,
	"pointer": `Home_pointer__LIICY`
};
export default ___CSS_LOADER_EXPORT___;
